import { useMutation } from "@tanstack/react-query";
import { useAuth } from "../contexts/AuthContext";

interface VerifyMfaPayload {
  code: string;
}

/**
 * FIX-11 (П0.1): завершает login, начатый AuthContext.login() с requiresMfa: true.
 * Делегирует в AuthContext.verifyMfaChallenge — там же хранится pending-токен и
 * выполняется его явная подстановка в заголовок Authorization (в обход обычного
 * axios-интерцептора, который подставляет основной accessToken).
 */
export function useVerifyMfa() {
  const { verifyMfaChallenge } = useAuth();

  return useMutation<void, Error, VerifyMfaPayload>({
    mutationFn: ({ code }) => verifyMfaChallenge(code),
  });
}
